import { useStaticQuery, graphql } from 'gatsby';

export const useSiteMetadata = selectedLocale => {
  const {
    allPrismicSiteMetadata: { edges: locales },
  } = useStaticQuery(graphql`
    query {
      allPrismicSiteMetadata {
        edges {
          node {
            id
            lang
            data {
              meta_description
              meta_title
              share_image {
                url
              }
            }
          }
        }
      }
    }
  `);

  return locales.filter(({ node }) => node.lang === selectedLocale);
};
